<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from 'echarts' // echarts theme
import { debounce } from '@/utils/util'
require('echarts/theme/macarons')
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      chart: null
    }
  },
  computed: {
    theme() {
      return this.$store.state.app.theme
    },
    deviceData() {
      return localStorage.getItem('deviceData') ? JSON.parse(localStorage.getItem('deviceData')) : []
    },
    deviceConfigInfoAttr() {
      return this.$store.state.user.deviceConfigInfo.attrParam
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.initChart()
    if (this.autoResize) {
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 600)
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler)
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setOptions({
      name,
      name1,
      unit,
      name2,
      time,
      y1,
      y2,
      limitMax1,
      limitMax2,
      limitMin1,
      limitMin2,
      key1,
      key2
    } = {}) {
      console.log(
        limitMax1,
        'limitMax1limitMax1',
        this.deviceData.find((item) => item.title.indexOf(name1) !== -1)
      )
      this.chart.setOption({
        title: {
          text: name + '(' + unit + ')'
        },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {}
          }
        },
        legend: {
          selected: {
            [name1]: this.deviceConfigInfoAttr[`${key1}`] === 1,
            [name2]: this.deviceConfigInfoAttr[`${key2}`] === 1
          }
        },
        // toolbox: {
        //   show: true,
        //   feature: {
        //     dataZoom: {
        //       yAxisIndex: 'none'
        //     },
        //     dataView: { readOnly: false },
        //     magicType: { type: ['line', 'bar'] },
        //     restore: {},
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: time
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' + unit
          }
        },
        dataZoom: [
          {
            type: 'slider',
            show: true,
            xAxisIndex: [0],
            handleSize: 0, // 滑动条的 左右2个滑动条的大小
            height: 10, // 组件高度
            left: 550, // 左边的距离
            right: 540, // 右边的距离
            bottom: 506, // 右边的距离
            handleColor: '#ddd' // h滑动图标的颜色
          },
          {
            type: 'inside',
            start: 0,
            end: 50,
            textStyle: {
              color: '#fff'
            }
          },
          {
            show: true,
            type: 'slider',
            // y: '94%',
            bottom: '0',
            start: 0,
            end: 50,
            textStyle: {
              color: '#fff'
            }
          }
        ],
        series: [
          {
            name: name1,
            type: 'line',
            data: y1
            // markPoint: {
            //   data: [
            //     { type: 'max', name: '最大值' },
            //     { type: 'min', name: '最小值' }
            //   ]
            // },
            // markLine: {
            //   data: [
            //     { type: 'max', name: '最大值' },
            //     { type: 'min', name: '最小值' }
            //   ],
            //   label: {
            //     formatter: '{b}: {c}'
            //   }
            // },
          },
          {
            name: name2,
            type: 'line',
            data: y2
            // markPoint: {
            //   data: [
            //     { type: 'max', name: '最大值' },
            //     { type: 'min', name: '最小值' }
            //   ]
            // }
          }
        ]
      })
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    }
  }
}
</script>
